import { ParseDateTime } from "helpers/Parsers.js"
import i18n from "i18n";

class BusinessNode
{
    id = null;
    code = null;
    number = null;
    type = null;
    name = null;
    address = null;
    locality = null;
    state = null;
    country = null;
    owner = null;
    email = null;
    phone = null;
    measure_height = null;
    measure_width = null;
    measure_depth = null;
    capacity = null;
    created_at = null;

    constructor(obj) {
	    // IF AN OBJECT WAS PASSED THEN INITIALISE PROPERTIES FROM THAT OBJECT
        for (var prop in obj) this[prop] = obj[prop];
        this.id = obj.code
      }

    getDescriptionPanelView() {
        return [
            {
                title: i18n.t("branch.number"),
                value: this.name
            },
            {
                title: i18n.t("id"),
                value: this.code
            },
            {
                title: i18n.t("creation.date"),
                value: ParseDateTime(this.created_at)
            },
            {
                title: i18n.t("location.stock"),
                value: this.address
            }
        ]
    }

    getContactPanelView() {
        return [
            {
                title: i18n.t("owner"),
                value: this.owner
            },
            {
                title: i18n.t("phone"),
                value: this.phone
            },
            {
                title: i18n.t("email"),
                value: this.email
            }
        ]
    }

    getDimensionsPanelView(){
        return [
            {
                title: `${i18n.t("measure_depth")} (mts)`,
                value: `${this.measure_depth ? this.measure_depth + ' mts' : i18n.t("without.informing") }`
            },
            {
                title: `${i18n.t("measure_height")} (mts)`,
                value: `${this.measure_height ? this.measure_height + ' mts' : i18n.t("without.informing") }`
            },
            {
                title: `${i18n.t("measure_width")} (mts)`,
                value: `${this.measure_width ? this.measure_width + ' mts' : i18n.t("without.informing") }`
            },
            {
                title: `${i18n.t("capacity")}`,
                value: `${this.capacity == null ? i18n.t("without.informing") : this.capacity + ' ' + i18n.t("without.informing") }`
            }
        ]
    }

    getLocationPanelView(){
        return {
            id: this.code,
            name: this.name,
        }
    }

    getGenericTableView(){
        return {
            id: this.code,
            name: this.name,
            country: this.country
            ? this.country.label
              ? this.country.label
              : this.country
            : "",
            locality: this.locality
            ? this.locality.label
              ? this.locality.label
              : this.locality
            : "",
            email: this.email,
            phone: this.phone
        }
    }
}
export {
    BusinessNode
}
